module.exports = __webpack_public_path__ + "static/media/sample_app.cc44211c.png";